import { Link } from "react-router-dom";
import { VERTICALS } from "@/lib/content";
import { TellUsButton } from "@/components/common/TellUsButton";

const legal = [
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms of Service", to: "/terms" },
  { label: "Cookie Policy", to: "/cookies" },
];

const company = [
  { label: "About SCC", to: "/about" },
  { label: "For Employers", to: "/for-employers" },
  { label: "For Candidates", to: "/for-candidates" },
  { label: "Contact", to: "/contact" },
];

export const Footer = () => (
  <footer className="relative z-[2] bg-navy text-white" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-28">
      <div className="grid gap-14 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
<div className="flex items-center">
  <img
    src="/success-crest-logo.png"
    alt="Success Crest Consulting"
    className="h-12 w-auto object-contain"
  />
</div>
          <p className="mt-6 max-w-sm font-heading text-2xl font-medium leading-snug tracking-tight text-slate-200">
            Different Needs.
            <br />
            Deliberate Solutions.
          </p>
          <div className="mt-8">
            <TellUsButton
              size="sm"
              className="bg-blue-600 hover:bg-blue-500"
              testId="footer-tell-us-cta"
            />
          </div>
        </div>

        <FooterCol title="Solutions">
          {VERTICALS.map((v) => (
            <Link key={v.id} to={`/services#${v.id}`} className="footer-link">
              {v.name}
            </Link>
          ))}
        </FooterCol>

        <FooterCol title="Company">
          {company.map((l) => (
            <Link key={l.to} to={l.to} className="footer-link">
              {l.label}
            </Link>
          ))}
        </FooterCol>

        <FooterCol title="Legal">
          {legal.map((l) => (
            <Link key={l.to} to={l.to} className="footer-link">
              {l.label}
            </Link>
          ))}
        </FooterCol>
      </div>

      <div className="mt-20 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-sm text-slate-400 md:flex-row md:items-center">
        <p>© {new Date().getFullYear()} Success Crest Consulting. All rights reserved.</p>
      </div>
    </div>

    <style>{`
      .footer-link { display:block; padding:.375rem 0; color:#94a3b8; font-size:.875rem; transition:color .2s ease; }
      .footer-link:hover { color:#fff; }
    `}</style>
  </footer>
);

const FooterCol = ({ title, children }) => (
  <div>
    <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">{title}</h4>
    <nav className="flex flex-col">{children}</nav>
  </div>
);
